import { render } from "./Delivery.vue?vue&type=template&id=5f9265b4"
const script = {}

import "./Delivery.vue?vue&type=style&index=0&id=5f9265b4&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__